import { Inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { LOGIN_PATH } from '../utils/application-structure';
import { UserNameService } from './user-name.service';
import { WINDOW } from '../tokens/window';
import { AuthorizationTokenService } from './authorization-token.service';

@Injectable({
  providedIn: 'root',
})
export class LoginRedirectService {
  private redirectUrl?: UrlTree | null;

  private sessionExpired: boolean;

  constructor(
    private userNameService: UserNameService,
    private authorizationTokenService: AuthorizationTokenService,
    private router: Router,
    @Inject(WINDOW) private window: Window,
  ) {
    this.sessionExpired = false;
    this.authorizationTokenService.authorizationToken$.subscribe((authorizationToken) => {
      if (authorizationToken == null) {
        this.redirectToLoginScreen();
      }
    });
  }

  exitToLoginScreen(sessionExpired?: boolean) {
    this.userNameService.setUserName(null);
    this.authorizationTokenService.setAuthorizationToken(null);
    this.sessionExpired = sessionExpired ?? false;
  }

  private redirectToLoginScreen() {
    if (this.redirectUrl == null) {
      const redirectUrl = this.window.location.hash.substr(1); // Remove '#' from url
      if (!redirectUrl.startsWith(`/${LOGIN_PATH}`)) {
        this.redirectUrl = this.router.parseUrl(redirectUrl);
      }
    }
    this.router.navigate([LOGIN_PATH]);
  }

  openApplication() {
    const redirectUrl = this.redirectUrl;
    this.redirectUrl = null;
    this.sessionExpired = false;
    if (redirectUrl != null) {
      this.router.navigateByUrl(redirectUrl);
    } else {
      this.router.navigate(['/']);
    }
  }

  isSessionExpired(): boolean {
    return this.sessionExpired;
  }
}
